import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export function AdminNotify() {
  const [email, setEmail] = useState("");
  const [saved, setSaved] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings/notify").then((r) => {
      setEmail(r.data.email);
      setSaved(r.data.email);
    });
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings/notify", { email });
      setSaved(data.email);
      setEmail(data.email);
      toast.success("Email de aviso salvo");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} className="mt-6 bg-white border border-zinc-200 rounded-lg p-6" data-testid="admin-notify">
      <BellRing className="w-6 h-6 text-[#0055FF]" />
      <h3 className="mt-3 font-display font-bold text-xl">Aviso de venda</h3>
      <p className="mt-1 text-sm text-zinc-600">A cada venda aprovada, enviamos um email com o valor, o evento e o cliente.</p>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        data-testid="notify-email-input"
        className="mt-4 w-full h-12 px-3 rounded-md border border-zinc-200 focus:outline-none focus:ring-2 focus:ring-[#0055FF]"
      />
      <button disabled={saving || email.trim().toLowerCase() === saved} data-testid="notify-save-btn" className="mt-5 h-12 px-6 rounded-md bg-[#0055FF] hover:bg-[#0040CC] disabled:opacity-50 text-white font-semibold">
        {saving ? "Salvando…" : "Salvar email"}
      </button>
    </form>
  );
}
